// extracted by mini-css-extract-plugin
export const header = "styles-module--header--hyGyp";
export const wrapper = "styles-module--wrapper--5T7I9";
export const right = "styles-module--right--1zAYK";
export const bgfull = "styles-module--bgfull--3BFhF";